/** Textos partilhados (meta, seletor de idioma, ações genéricas). */
const pt = {
    "meta.title": "Zaralha Servers (ZRS) — Servidor de Rust BR 3x com Kits, TP e VIPs",
    "meta.description":
        "Zaralha Servers (ZRS): servidor de Rust brasileiro 3x Moded com kits, teleporte, minicopter e wipe semanal às sextas. VIPs com kits exclusivos, assistente ZaroAI e comunidade no Discord.",
    "lang.label": "Idioma",
    "lang.switchTo": "Mudar para inglês",
    "common.close": "Fechar",
};
const en = {
    "meta.title": "Zaralha Servers (ZRS) — Brazilian Rust 3x Server with Kits, TP & VIPs",
    "meta.description":
        "Zaralha Servers (ZRS): Brazilian Rust 3x modded server with kits, teleport, minicopter and weekly Friday wipes. VIPs with exclusive kits, the ZaroAI assistant and a Discord community.",
    "lang.label": "Language",
    "lang.switchTo": "Switch to Portuguese",
    "common.close": "Close",
};

export default { pt, en };
